import {Component, OnInit, inject} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {QuickTourService} from '@jtm/jtm-services';
// import {QuickTourSliderItem, QuickTourVersion} from '@jtm/jtm-services/lib/services/quick-tour/quick-tour.interface';
import {UntilDestroy} from '@jumio/portals.core';
import {Subscription} from 'rxjs';
import {WelcomeRedirectService} from '../../services/redirect/redirect.service';
import {QuickTourViewComponent} from './quick-tour-view/quick-tour-view.component';

// Local type definitions for JTM services types that aren't exported
// See docs/angular-migration-v17-v21/JTM_MISSING_TYPE_EXPORTS.md for details
interface QuickTourSliderItem {
  image: string;
  heading: string;
  title: string;
  subHeading: string;
  bodyTextItems: {
    title: string;
    item: string;
  }[];
  labelButton: string;
}

interface QuickTourVersion {
  version: string;
  date: string;
}

@UntilDestroy()
@Component({
  selector: 'app-quick-tour',
  template: '',
  standalone: false
})
export class QuickTourComponent implements OnInit {
  private welcomeRedirectService = inject(WelcomeRedirectService);
  private quickTourService = inject(QuickTourService);
  private dialog = inject(MatDialog);

  public quickTourVersionDate: QuickTourVersion | undefined;
  public quickTourSliderItems: QuickTourSliderItem[] = [];
  public readonly subscription = new Subscription();

  ngOnInit(): void {
    this.quickTourVersionDate = this.quickTourService.getQuickTourVersionDate();
    this.quickTourSliderItems = this.quickTourService.getQuickTourSliderItems();
    this.openDialog();
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(QuickTourViewComponent, {
      disableClose: true,
      panelClass: 'custom-modal-box',
      backdropClass: 'custom-modal-box-background',
      data: {
        quickTourSliderItems: {...this.quickTourSliderItems}
      }
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed && this.quickTourVersionDate) {
          this.quickTourService.saveUserPreferencesQuickTour(this.quickTourVersionDate);
          this.redirectToHomePage();
        }
      })
    );
  }

  public redirectToHomePage(): void {
    this.subscription.add(
      this.welcomeRedirectService.getFirstAvailableRoute$().subscribe({
        next: url => {
          this.welcomeRedirectService.directsToPath(url);
        },
        error: err => {
          this.welcomeRedirectService.directsToLoginPage({error: err.status, message: err.error, errorUrl: err.url});
        }
      })
    );
  }
}
